const INITIAL_STATE = {
    data: null
}

const DefinicoesSistema = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'definicoesSistema': {

            return {
                ...state,
                data: action.payload.definicoesSistema
            }
        }
        default: {
            return state
        }
    }
}

export default DefinicoesSistema